import { Box } from '@common-components';

export function LoadingDots() {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        '@keyframes bouncing-loader': {
          to: {
            opacity: 0.1,
            transform: 'translateY(-4px)',
          },
        },
        '& > div': {
          width: '4px',
          height: '4px',
          margin: '1px 2px',
          borderRadius: '50%',
          backgroundColor: '#a3a1a1',
          opacity: 1,
          animation: 'bouncing-loader 0.6s infinite alternate',
        },
        '& > div:nth-of-type(2)': {
          animationDelay: '0.2s',
        },
        '& > div:nth-of-type(3)': {
          animationDelay: '0.4s',
        },
      }}
    >
      <div />
      <div />
      <div />
    </Box>
  );
}
